@solidale = angular.module('solidale', ['ng', 'ngAnimate', 'ngAria', 'ui.router', 'ngCookies', 'ngRoute', 'ui.bootstrap', 'ngMaterial', 'uiGmapgoogle-maps','ngMessages', 'ngFileUpload', 'ngStorage'])

# @solidale.constant('API_URL', 'http://127.0.0.1:8000')
@solidale.constant('API_URL', 'http://www.solidaire.kyoto')

@solidale.factory('myHttpResponseInterceptor', ['$q', '$location', '$localStorage', ($q, $location, $localStorage) ->
    
    return {
      'request': (config) ->
        config.headers = config.headers || {}

        if ($localStorage.token) 
          config.headers.Authorization = 'Bearer ' + $localStorage.token

        return config
      ,

      'responseError': (response) ->
        if (response.status == 401 || response.status == 403)
          $location.path('/')
        return $q.reject(response)
    }
])

@solidale.config(['$httpProvider', ($httpProvider) ->
  $httpProvider.interceptors.push('myHttpResponseInterceptor')
])

@solidale.config(['uiGmapGoogleMapApiProvider', (uiGmapGoogleMapApiProvider) ->
	uiGmapGoogleMapApiProvider.configure
    v: '3.20'
    libraries: 'places'
    key: 'AIzaSyAguEYj6gz2SIBpFNdNfxb1IKvKnoc00dA'
    language: 'zh-TW'
])

@solidale.config(['$stateProvider', '$urlRouterProvider', '$locationProvider', ($stateProvider, $urlRouterProvider, $locationProvider) -> 

  normal = ($q, $rootScope, $state)->
    $rootScope.fullAuthorize().then ()->
      $q.when()

  authenticate = ($q, $rootScope, $state, $timeout) ->
    $rootScope.fullAuthorize().then ()->

      if ($rootScope.isAuthenticated)
        $q.when()
      else
        $timeout () ->
          $state.go('home')

        $q.reject({detail: 'not authorized'})

  admincheck = ($q, $rootScope, $state, $timeout) ->
    $rootScope.fullAuthorize().then () ->
      console.log 'authorize done'
      
      if ($rootScope.isAuthenticated && $rootScope.isAdmin)
        $q.when()
      else
        $timeout () ->
          $state.go('home')

        $q.reject({detail: 'not authorized'})


  $stateProvider
  .state('home', {
    url: '/'
    templateUrl: 'views/home.html'
    controller: 'HomeCtrl'
    resolve: 
      authenticate: normal
  })

  .state('locAdd', {
    url: '/loc/add'
    templateUrl: 'views/loc_add.html'
    controller: 'LocAddCtrl'
    resolve: 
      authenticate: admincheck
  })
  .state('locModify', {
    url: '/loc/admin'
    templateUrl: 'views/loc_modify.html'
    controller: 'LocModifyCtrl'
    resolve: 
      authenticate: admincheck
  })

  .state('locIndex', {
    url: '/loc/all'
    templateUrl: 'views/loc_index.html'
    controller: 'LocIndexCtrl'
    resolve: 
      authenticate: authenticate
  })
  .state('locShow', {
    url: '/loc/show/:locid'
    templateUrl: 'views/loc_show.html'
    controller: 'LocShowCtrl'
    resolve: 
      authenticate: authenticate
  })
  .state('locRequest', {
    url: '/loc/request'
    templateUrl: 'views/loc_request.html'
    controller: 'LocRequestCtrl'
    resolve: 
      authenticate: authenticate
  })
  .state('myfav', {
    url: '/loc/myfav'
    templateUrl: 'views/loc_myfav.html'
    controller: 'LocMyfavCtrl'
    resolve: 
      authenticate: authenticate
  })

  .state('concept', {
    url: '/sub/concept'
    templateUrl: 'views/subpage/concept.html'
    resolve: 
      authenticate: normal
  })
  .state('elder', {
    url: '/sub/elder'
    templateUrl: 'views/subpage/elder.html'
    resolve: 
      authenticate: normal
  })
  .state('younger', {
    url: '/sub/younger'
    templateUrl: 'views/subpage/younger.html'
    resolve: 
      authenticate: normal
  })
  .state('pwdreset', {
    url: '/password/reset/:token/:email'
    templateUrl: 'views/pwdreset.html'
    controller: 'PwdResetCtrl'
    resolve: 
      authenticate: normal
  })


  $urlRouterProvider.otherwise('/')
  $locationProvider.html5Mode(true)

])

@solidale.run ($rootScope, $state, $q, $localStorage, Data)->

  $rootScope.isAuthenticated = false
  $rootScope.isAdmin = false

  $getToken = ()->
    defer = $q.defer()
    
    console.log 'Token searching'
    $rootScope.token = $localStorage.token

    defer.resolve $rootScope.token
    defer.promise

  $checkToken = ()->
    defer = $q.defer()
    
    if $rootScope.token
      console.log 'token exist'
      $rootScope.isAuthenticated = true

      $getUser().then ()->
        $done = true

        defer.resolve $done
        defer.promise

    else
      console.log 'no token found'
      $rootScope.isAuthenticated = false
      $done = true

      defer.resolve $done
      defer.promise

  $getUser = () ->
    Data.getRestrictedData($successUser, (error) ->
      console.log 'token expired!'
      $rootScope.isAuthenticated = false
      
      $rootScope.token = ''
      $localStorage.token = ''
    ) 

  $successUser = (user) ->
    console.log 'token valid'
    $rootScope.user = user
    $rootScope.isAuthenticated = true
    console.log 'hello: '+$rootScope.user.name

    if $rootScope.user.is_admin == '1'
      $rootScope.isAdmin = true
    else
      $rootScope.isAdmin = false

  $rootScope.fullAuthorize = () ->  
    $getToken().then ()->
      $checkToken().then ()->

@solidale.directive 'mheader', () ->
  restrict: 'E'
  templateUrl: 'views/header.html'
  controller: 'HeaderCtrl'

@solidale.directive 'mfooter', () ->
  restrict: 'E'
  templateUrl: 'views/footer.html'

@solidale.directive 'mloading', () ->
  restrict: 'E'
  scope:
    isloading: '=isloading'
  templateUrl: 'views/loading.html'

@solidale.directive 'mcomplete', ()->
  restrict: 'E'
  scope:
    iscomplete: '=iscomplete'
    completetext: '=completetext'
  templateUrl: 'views/complete.html'

@solidale.directive 'locitem', () ->
  restrict: 'E'
  scope:
    loc: '='
  templateUrl: 'views/directive/locitem.html'
  controller: 'LocItemCtrl'

@solidale.directive 'locitemback', () ->
  restrict: 'E'
  templateUrl: 'views/directive/locitemback.html'
  scope: {
    imgobj: '=imgobj'
  }
  link: ($scope)->
    $scope.back = $scope.imgobj.path + $scope.imgobj.image_name

@solidale.directive 'photoitem', ()->
  restrict: 'E'
  template: '<div class="photo-item-wrapper"><div class="photo"><imgwrap imgobj="photoobj"></imgwrap></div><div class="desc"><p>{{ photoobj.desc }}</p></div>
  </div>'
  scope: {
    photoobj: '=photoobj'
  }

@solidale.directive 'imgwrap', ()->
  restrict: 'E'
  template: '<img ng-src="{{imgr}}" alt="locimg"/>'
  scope: {
    imgobj: '=imgobj'
  }
  link: ($scope)->
    $scope.imgr = $scope.imgobj.path + $scope.imgobj.image_name

@solidale.directive 'infocusitem', () ->
  restrict: 'E'
  scope:
    infocus: '='
    inifocusitem: '='
    location: '=location'
  templateUrl: 'views/directive/locfocusitem.html'
  controller: 'LocFocusItemCtrl'

@solidale.directive 'photomodify', ()->
  restrict: 'E'
  scope:
    inputphoto: '=inputphoto'
    outputphoto: '='
  templateUrl: 'views/directive/photomodify.html'
  controller: 'PhotoModifyCtrl'

@solidale.directive 'roommodify', ()->
  restrict: 'E'
  scope:
    inputroom: '=inputroom'
    outputroom: '='
  templateUrl: 'views/directive/roommodify.html'
  controller: 'RoomModifyCtrl'

@solidale.directive 'likeit', ()->
  restrict: 'E'
  scope:
    location: '=location'
  templateUrl: 'views/directive/likeit.html'
  controller: 'LikeItCtrl'
  

@solidale.directive 'mindate', ()->
  restrict: 'E'
  scope:
    indate: '=indate'
  template: '{{ outdate }}'
  link: ($scope)->
    $scope.outdate = $scope.indate.substring(0, 11)

@solidale.directive 'state1', ()->
  restrict: 'E'
  scope:
    status: '=status'
    items: '=items'
    refresh: '='
  templateUrl: 'views/directive/request/state1.html'
  controller: 'RequestStateOneCtrl'

@solidale.directive 'state2', ()->
  restrict: 'E'
  scope:
    status: '=status'
    items: '=items'
    refresh: '='
  templateUrl: 'views/directive/request/state2.html'
  controller: 'RequestStateTwoCtrl'

@solidale.directive 'state3', ()->
  restrict: 'E'
  scope:
    status: '=status'
    items: '=items'
    refresh: '='
  templateUrl: 'views/directive/request/state3.html'
  controller: 'RequestStateThreeCtrl'

@solidale.directive 'state4', ()->
  restrict: 'E'
  scope:
    status: '=status'
    items: '=items'
    refresh: '='
  templateUrl: 'views/directive/request/state4.html'
  controller: 'RequestStateFourCtrl'
